'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	return function (session, instance) {
		if (!session) {
			return '';
		}

		var hours;

		if (session.overwriteDuration && instance in session.overwriteDuration) {
			hours = session.overwriteDuration[instance];
		} else {
			hours = session.duration;
		}

		return hours;
	};
};


// WEBPACK FOOTER //
// ./client/components/misc-services/hour-finder.js